import { toFinite } from 'lodash';

const DEFAULT_OPTIONS = {
  minimumFractionDigits: 0, // min # of decimals
  maximumFractionDigits: 0, // max # of decimals
};

// 1234567 => "1,234,567"
export const numberToLocaleString = (
  number,
  options = {}
) => toFinite(number).toLocaleString('en', {
  ...DEFAULT_OPTIONS,
  ...options,
});
